import { Pipe, PipeTransform } from '@angular/core';
import { MessageSubject } from '../pipes/messageSubject';

@Pipe({
  name: 'orderSubjects'
})
export class OrderSubjectsPipe implements PipeTransform {
  transform(subjects: MessageSubject[]): any {
    // transform(subjects: MessageSubject[], arg): any {
    return subjects ? subjects.sort(this.sortByPriority) : subjects;
  }

  private sortByPriority(subject1: MessageSubject, subject2: MessageSubject): number {
    if (subject1 && subject2 && subject1.priority && subject2.priority) {
      if (subject1.priority < subject2.priority) {
        return -1;
      } else if (subject1.priority > subject2.priority) {
        return 1;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/order-subjects.pipe.ts